import {useTranslation} from "react-i18next";
import {LanguageType, useTimer} from "modules";
import {
	EXTRA_VOTE_END,
	HRS_IN_DAY,
	MIN_IN_HOUR,
	MS_IN_SECOND,
	SEC_IN_DAY,
	SEC_IN_HOUR,
	SEC_IN_MINUTE,
	VOTE_END,
} from "apps/BUDWEISERPOTM/modules/constants";
import {useMemo} from "react";
import {IPredictorGame} from "apps/BUDWEISERPOTM/modules/actions";

const getShareMessagesForLang = {
	[LanguageType.EN]: (roundName: string, competitionName: string) => {
		return `I've just voted for my favourite Moment in the ${roundName} of the ${competitionName}! What's yours?`;
	},
	[LanguageType.DE]: (roundName: string, competitionName: string) => {
		return `Ich habe gerade für meinen Lieblingsmoment in der ${roundName} des ${competitionName} gestimmt! Was ist deiner?`;
	},
	[LanguageType.FR]: (roundName: string, competitionName: string) => {
		return `Je viens de voter pour mon Moment préféré en ${roundName} de ${competitionName} ! Quel est le tien ?`;
	},
	[LanguageType.ES]: (roundName: string, competitionName: string) => {
		return `¡Acabo de votar por mi Momento favorito en la ${roundName} de la ${competitionName}! ¿Cuál es el tuyo?`;
	},
	[LanguageType.AR]: (roundName: string, competitionName: string) => {
		return `لقد قمت بالتصويت على لحظتي المفضّلة في ${roundName} من ${competitionName}! ما هي اللحظة المفضلة بالنسبة لك؟`;
	},
	[LanguageType.ID]: (roundName: string, competitionName: string) => {
		return `I've just voted for my favourite Moment in the ${roundName} of the ${competitionName}! What's yours?`;
	},
	[LanguageType.KO]: (roundName: string, competitionName: string) => {
		return `I've just voted for my favourite Moment in the ${roundName} of the ${competitionName}! What's yours?`;
	},
	[LanguageType.PT]: (roundName: string, competitionName: string) => {
		return `I've just voted for my favourite Moment in the ${roundName} of the ${competitionName}! What's yours?`;
	},
};

export const useShareMessage = () => {
	const {i18n} = useTranslation();
	const roundName = "round name";
	const competitionName = "comp name";
	return getShareMessagesForLang[i18n.language as LanguageType](roundName, competitionName);
};

export const useTimerData = ({end}: {end: string}) => {
	const time = useTimer(end);
	const milliseconds = time.milliseconds;
	const secToFinish = Math.floor(milliseconds / MS_IN_SECOND);
	const days = Math.floor(secToFinish / SEC_IN_DAY);
	const hours = Math.floor(secToFinish / SEC_IN_HOUR) % HRS_IN_DAY;
	const minutes = Math.floor(secToFinish / MIN_IN_HOUR) % MIN_IN_HOUR;
	const seconds = Math.floor(
		secToFinish - days * SEC_IN_DAY - hours * SEC_IN_HOUR - minutes * SEC_IN_MINUTE
	);

	return {
		days,
		hours,
		minutes,
		seconds,
	};
};

export const useVoteEndTime = (match?: IPredictorGame) => {
	return useMemo(() => {
		const minute = match?.minute || 0;

		const end = minute > 90 ? EXTRA_VOTE_END : VOTE_END;
		const diff = end - minute;
		return new Date(new Date().getTime() + diff * 60000).toISOString();
	}, [match]);
};
